import { useEffect, useState } from "react";
import { X } from "lucide-react";
import api from "../api";

const BlobImg = ({ id, style, className }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url = null;
    api.get(`/photos/${id}/image`, { responseType: "blob" }).then(({ data }) => {
      url = URL.createObjectURL(data);
      setSrc(url);
    }).catch(() => {});
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [id]);
  if (!src) return null;
  return <img src={src} alt="" className={className} style={style} draggable={false} />;
};

export const PhotoCompare = ({ a, b, onClose }) => {
  const [pos, setPos] = useState(50);
  return (
    <div className="fixed inset-0 z-[70] bg-black/95 flex flex-col" data-testid="photo-compare">
      <div className="flex items-center justify-between p-4">
        <p className="font-display text-2xl text-white">AVANT / APRÈS</p>
        <button data-testid="compare-close" onClick={onClose} className="text-[#B0B0B4] hover:text-white p-2 transition-colors">
          <X size={22} />
        </button>
      </div>
      <div className="flex-1 flex items-center justify-center px-4 overflow-hidden">
        <div className="relative w-full max-w-md aspect-[3/4] overflow-hidden border border-white/15 select-none">
          <BlobImg id={a.id} className="absolute inset-0 w-full h-full object-cover" />
          <BlobImg id={b.id} className="absolute inset-0 w-full h-full object-cover"
            style={{ clipPath: `inset(0 0 0 ${pos}%)` }} />
          <div className="absolute top-0 bottom-0 w-[3px] bg-[#FF3B30] pointer-events-none" style={{ left: `${pos}%` }}>
            <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-8 h-8 rounded-full bg-[#FF3B30] flex items-center justify-center text-white text-xs font-bold">⇄</div>
          </div>
          <div className="absolute top-2 left-2 bg-black/70 px-2 py-1">
            <p className="text-white text-xs font-medium">{a.label}</p>
            <p className="text-[#B0B0B4] text-[10px]">{a.date}</p>
          </div>
          <div className="absolute top-2 right-2 bg-black/70 px-2 py-1 text-right">
            <p className="text-white text-xs font-medium">{b.label}</p>
            <p className="text-[#B0B0B4] text-[10px]">{b.date}</p>
          </div>
        </div>
      </div>
      <div className="p-6 pb-10 max-w-md w-full mx-auto">
        <input data-testid="compare-slider" type="range" min="0" max="100" value={pos}
          onChange={(e) => setPos(parseInt(e.target.value, 10))} className="compare-range w-full" />
        <p className="text-[#B0B0B4] text-[10px] text-center mt-2">Glisse le curseur pour comparer</p>
      </div>
    </div>
  );
};
